/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'

const CampaignContext = createContext()

export const useCampaign = () => useContext(CampaignContext)

export const CampaignProvider = ({
  location,
  utmHomeContents = [],
  proPromoContents = [],
  children,
}) => {
  const [utmCampaign, setUTMCampaign] = useState('')
  const [utmContent, setUTMContent] = useState()
  const [utmContentExpired, setUTMContentExpired] = useState()
  const [promoCampaign, setPromoCampaign] = useState('')
  const [promoOfferEndDate, setPromoOfferEndDate] = useState()
  const [promoBannerTitle, setPromoBannerTitle] = useState()
  const [promoBannerTitleExpired, setPromoBannerTitleExpired] = useState()
  const [isExpired, setExpired] = useState(false)

  const utmProcess = useCallback(() => {
    const params = new URLSearchParams(location?.search)
    const utm_campaign = params.get('utm_campaign')
    const promo_campaign = params.get('promo_campaign')

    setUTMCampaign(utm_campaign)
    setPromoCampaign(promo_campaign)

    if (promo_campaign) {
      const promoIndex = proPromoContents.findIndex(
        (item) => item.promoProTitle === promo_campaign
      )

      if (promoIndex >= 0) {
        const promoItem = proPromoContents[promoIndex]
        setPromoOfferEndDate(promoItem.offerEndDate)
        setPromoBannerTitle(promoItem.bannerTitle)
        setPromoBannerTitleExpired(promoItem.bannerTitleExpired)
        setUTMContent(isExpired ? promoItem.utmforover : promoItem.utmContent)
        setUTMContentExpired(promoItem.utmforover)

        window.localStorage.setItem('promoOfferEndDate', promoItem.offerEndDate)
        window.localStorage.setItem(
          'utmContent',
          JSON.stringify(promoItem.utmContent)
        )
        window.localStorage.setItem('bannerTitle', promoItem.bannerTitle)
        window.localStorage.setItem(
          'bannerTitleExpired',
          promoItem.bannerTitleExpired
        )
      } else {
        setUTMContent(utmHomeContents.find((item) => item.utmParam === 'home'))
      }
    } else {
      const utmIndex = utmHomeContents.findIndex(
        (item) => item.utmParam === utm_campaign
      )

      if (utmIndex < 0) {
        const savedOfferEndDate =
          window.localStorage.getItem('promoOfferEndDate')

        if (savedOfferEndDate) {
          const timeDiff = new Date(savedOfferEndDate) - new Date()

          if (timeDiff < 0) {
            setPromoOfferEndDate()
            setUTMContent(
              utmHomeContents.find((item) => item.utmParam === 'home')
            )
          } else {
            setPromoOfferEndDate(savedOfferEndDate)
            setUTMContent(JSON.parse(window.localStorage.getItem('utmContent')))
            setPromoBannerTitle(window.localStorage.getItem('bannerTitle'))
            setPromoBannerTitleExpired(
              window.localStorage.getItem('bannerTitleExpired')
            )
          }
        } else {
          setUTMContent(
            utmHomeContents.find((item) => item.utmParam === 'home')
          )
        }
      } else {
        setUTMContent(utmHomeContents[utmIndex])
      }
    }
  }, [location, utmHomeContents, proPromoContents, isExpired])

  useEffect(() => {
    utmProcess()
  }, [isExpired])

  return (
    <CampaignContext.Provider
      value={{
        utmCampaign,
        promoCampaign,
        utmContent,
        utmContentExpired,
        promoOfferEndDate,
        promoBannerTitle,
        promoBannerTitleExpired,
        isExpired,
        setExpired,
      }}
    >
      {children}
    </CampaignContext.Provider>
  )
}
